export const loginStyles = {
  titleMessage: {
    fontSize: 30,
    fontWeight: 300,
    marginTop: 16,
    marginBottom: 25,
  },
  loginInput: {
    minWidth: "300px",
    maxWidth: "300px",
  },
  instructionsMessage: {
    fontSize: 15,
    margin: "25px 10px 25px",
  },
  checkbox: {
    marginLeft: 1,
    fontWeight: 500,
    lineHeight: 16,
    fontSize: 10,
    marginTop: 5,
    marginBottom: 20,
  },
  forgotPassword: {
    fontSize: "13px",
    paddingBottom: "12px",
  },
  logoLogin: {
    marginTop: "16px",
    marginBottom: "24px",
    width: "calc(237px * 0.80)",
    height: "calc(58px * 0.80)",
    background: "url(https://hc-images2.s3.amazonaws.com/haven_logo_light.png) no-repeat",
    backgroundSize: "contain",
  },
  textContainer: {
    maxWidth: 350,
    margin: "0px auto 0px",
    width: "auto",
  },
  bottomLink: {
    marginTop: 25,
    textAlign: "center" as const,
    fontSize: 13,
    paddingBottom: 16,
  },
  btn: {
    marginTop: 26,
    minWidth: "280px",
  },
  card: {
    maxWidth: "350px",
    marginTop: 16,
  },
  passwordRequirements: {
    fontSize: 14,
    marginTop: 16,
  },
} as const;
